import { BehaviorSubject, Observable } from 'rxjs';
import {DoorCorners, ScenarioType} from "../../models/scenario-image";
import {Product, ProductType} from "../../models/product";
import { ProductsMap} from "./door.service.impl";
import {DoorType} from "../../models/door";
import {LoadedProduct} from "../../panels/abstract.door-panel.component";

export abstract class DoorService {
  isLoading$ = new BehaviorSubject<boolean>(false);

  abstract getProducts$(): Observable<Array<Product>>

  abstract getProductsObservable(): Observable<Array<Product>>

  abstract showNextPageLoadingIndicator(): boolean

  abstract loadNextPage(): void;

  abstract hasNextPage(): boolean;

  abstract getSelected$(): Observable<ProductsMap>;

  abstract getSelectedProductsAtCurrentIndex(): Array<Product> | undefined;
  abstract getSelectedDoorAtCurrentIndex(): Product | undefined
  abstract getSelectedIndex(): number
  abstract getSelectedDoorAtIndex(index: number): Product | undefined
  abstract getSelectedDoorAtCurrentIndex$(): Observable<Product | undefined>

  abstract getSelectedDoorType$(): Observable<DoorType | undefined>

  abstract getDefaultProductForType({productType, visualDoorId}: { productType: ProductType, visualDoorId: string }): Promise<Product | undefined>

  abstract getSelectedProductsAtIndex(index: number): Array<Product> | undefined;

  abstract selectProductsAtIndex(products: Array<{ index: number; products: Array<Product> }>): void
  abstract selectProductAtCurrentIndex(product: LoadedProduct): void;

  abstract showNextProductAtCurrentIndex(): void;
  abstract showPrevProductAtCurrentIndex(): void;

  abstract toggleFavorite(product: Product): void;

  abstract getFavoritesCount(): Observable<number>;

  abstract getDoorByExternalId(externalId: string): Promise<Product | undefined>;

  abstract setSelectedProductsByExternalIds(products: Array<{ index: number, door?: string, products?: Array<string> }>): Promise<void>

  // Defines which door corners are selected to visualize the door (for multiple door visualization)
  abstract getSelectableIndex$(): Observable<Array<number>>;
  abstract selectedDoorCorners(doorCorners: DoorCorners, currentScenarioType: ScenarioType | undefined): void
  abstract selectDoorCornersIndex(index: number): void
  abstract getSelectedDoorCornersIndex(): Observable<number>;
  abstract getSelectedDoorCornersIndexValue(): number
}
